import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/Login';
import Logout from '@/components/Logout';
import PasswordReset from '@/components/PasswordReset';
import Verify from '@/components/Verify';
import DocumentSets from '@/components/DocumentSets';
import DocumentsView from '@/components/DocumentsView';
import DocumentsShare from '@/components/DocumentsShare';
import DocumentsInvitations from '@/components/DocumentsInvitations';
import PrimaryAttorneyDisplay from '@/components/PrimaryAttorneyDisplay';
import Terms from '@/components/Terms';
import Privacy from '@/components/Privacy';
import UserSettings from '@/components/UserSettings';
import AcceptInvitation from '@/components/AcceptInvitation';

import UserService from '@/services/user.service';

Vue.use(Router)
var router =  new Router({
    routes: [{
        path: '/login',
        name: 'Login',
        component: Login,
        meta: { public: true }
    }, {
        path: '/password-reset',
        name: 'PasswordReset',
        component: PasswordReset,
        meta: { public: true }
    }, {
        path: '/terms',
        name: 'Terms',
        component: Terms,
        meta: { public: true }
    }, {
        path: '/privacy',
        name: 'Privacy',
        component: Privacy,
        meta: { public: true }
    }, {
        path: '/accept-invitation',
        name: 'AcceptInvitation',
        component: AcceptInvitation,
        meta: { public: true }
    }, {
        path: '/verify',
        name: 'Verify',
        component: Verify,
        meta: { public: false }
    }, {
        path: '/',
        name: 'DocumentSets',
        component: DocumentSets
    }, {
        path: '/documents-view/:setType/:setId',
        name: 'DocumentsView',
        component: DocumentsView
    }, {
        path: '/documents-view/:setType/:setId/share',
        name: 'DocumentsShare',
        component: DocumentsShare,
    }, {
        path: '/documents-view/:setType/:setId/invite',
        name: 'DocumentsInvitations',
        component: DocumentsInvitations
    }, {
        path: '/user-settings',
        name: 'UserSettings',
        component: UserSettings
    }, {
        path: '/logout',
        name: 'Logout',
        component: Logout
    }]

});

router.beforeEach(function(to, from, next) {
    if (to.name == 'Logout') {
        UserService.logout()
            .then(logoutComplete)
            .catch(function (error) {
                console.log(error);
                next(false);
            });
    }
    if ( to.meta.public ) {
        next();
    } else {
        UserService.get()
            .then(checkVerification)
            .catch(noUser);
    }

    function checkVerification(user) {
        if (to.name == 'Verify') {
            if (user.isVerified) {
                next('/');
            } else {
                next();
            }
        } else {
            if (user.isVerified) {
                next();
            } else {
                console.log('Route guard found unverified user, redirecting for verification.');
                next('/verify');
            }
        }
    }

    function logoutComplete() {
        next('/login');
    }

    function noUser(reason) {
        console.log('Route guard found no user, redirecting to login.');
        next('/login?redirect=' + encodeURIComponent(to.fullPath));
    }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js